// import React, { useEffect } from "react";

const LoginRedirectModal = ({
  open,
  seconds,
  onCancel,
  onProceed,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-sm bg-white rounded-xl p-6 animate-fadeIn">

        {/* TITLE */}
        <h3 className="text-base font-semibold mb-2">
          Login Required
        </h3>

        {/* MESSAGE */}
        <p className="text-sm text-gray-600 mb-4">
          Kindly login to proceed to checkout.
        </p>

        {/* COUNTDOWN */}
        <p className="text-sm text-blue-600 font-medium mb-6">
          Redirecting to login in <span className="font-bold">{seconds}</span> seconds…
        </p>

        {/* ACTIONS */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm border rounded-lg"
          >
            Cancel
          </button>

          <button
            onClick={onProceed}
            className="px-4 py-2 text-sm bg-[#007BFF] text-white rounded-lg"
          >
            Login Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginRedirectModal;
